export default __webpack_public_path__ + "static/media/IMG22.a796fc79.jpg";